export default __webpack_public_path__ + "static/media/cs_icon_07_on.de940d59.png";